import { apiCall } from './gqlClient';

const ATHLETESESSIONLOGS_QUERY = `
  query athleteSessionLogs($athleteWorkoutPlanId: String!) {
    athleteSessionLogs(athleteWorkoutPlanId: $athleteWorkoutPlanId)
    {
      id
			athleteWorkoutPlanId
			sessionId
			status
			completionPercentage
			difficultyRating
			timing
			exercises
			note
			loggedAt
			createdAt
      ...fragments
    }
  }`;

export const athleteSessionLogsApiCall = async ({athleteWorkoutPlanId}, fragments = null) => apiCall({ query: ATHLETESESSIONLOGS_QUERY, variables: {athleteWorkoutPlanId}, fragments });

const LOGATHLETESESSION_QUERY = `
  mutation logAthleteSession($input: AthleteSessionLogInput!) {
    logAthleteSession(input: $input)
    {
      id
			athleteWorkoutPlanId
			sessionId
			status
			completionPercentage
			difficultyRating
			timing
			exercises
			note
			loggedAt
			createdAt
      ...fragments
    }
  }`;

export const logAthleteSessionApiCall = async ({input}, fragments = null) => apiCall({ query: LOGATHLETESESSION_QUERY, variables: {input}, fragments });
